import React from "react";
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ReactHtml from 'raw-html-react';

import { updateQuestion } from '../../actions/';
import TextFiled from '../FillFiled/TextFiled';
import configData from "../../../../Config/CustomStyle.json";
import QuestionTitle from '../QuestionTitle/';
import AiStatsModal from "../../../../Common/AiStatsModal";
import { getToken } from '../../../../../context/auth';

const convertEvaluationJsonToHtml = (evalObj) => {
    if (!evalObj) return '';
    const userMark = evalObj.userMark !== undefined ? evalObj.userMark : 0;
    const maxMark = evalObj.maxMark !== undefined ? evalObj.maxMark : 10;
    const ratingLevel = evalObj.ratingLevel || 'تقييم الإجابة';
    const summaryAdvice = evalObj.summaryAdvice || '';
    const blanks = evalObj.blanks || [];
    const starsCount = evalObj.starsCount !== undefined ? evalObj.starsCount : Math.min(5, Math.max(0, (userMark / (maxMark || 1)) * 5));

    const filledStars = Math.floor(starsCount);
    const hasHalfStar = (starsCount - filledStars) >= 0.25 && (starsCount - filledStars) <= 0.75;
    const emptyStars = Math.max(0, 5 - filledStars - (hasHalfStar ? 1 : 0));

    let starsHtml = '';
    for (let i = 0; i < filledStars; i++) starsHtml += `<i class='fas fa-star' style='color: #fbbf24; margin-left: 2px;'></i>`;
    if (hasHalfStar) starsHtml += `<i class='fas fa-star-half-alt' style='color: #fbbf24; transform: scaleX(-1); display: inline-block; margin-left: 2px;'></i>`;
    for (let i = 0; i < emptyStars; i++) starsHtml += `<i class='far fa-star' style='color: #cbd5e1; margin-left: 2px;'></i>`;

    let blanksRowsHtml = '';
    blanks.forEach(b => {
        let badgeHtml = '';
        if (b.status === 'correct' || b.isCorrect) {
            badgeHtml = `<i class='fas fa-check-circle' style='color: #10b981; margin-left: 5px;'></i> إجابة صحيحة`;
        } else if (b.status === 'partial') {
            badgeHtml = `<i class='fas fa-exclamation-triangle' style='color: #f59e0b; margin-left: 5px;'></i> إجابة ناقصة`;
        } else {
            badgeHtml = `<i class='fas fa-times-circle' style='color: #ef4444; margin-left: 5px;'></i> غير صحيحة`;
        }

        blanksRowsHtml += `
            <tr style='border-bottom: 1px solid #f1f5f9;'>
              <td style='padding: 10px; color: #1e293b; font-size: 13px; font-weight: 600;'>${b.context || ''}</td>
              <td style='padding: 10px; color: #334155; font-size: 13px;'>${b.studentAnswer || ''}</td>
              <td style='padding: 10px; color: #334155; font-size: 13px;'>${badgeHtml}</td>
              <td style='padding: 10px; color: #334155; font-size: 13px; font-weight: bold;'>${b.mark !== undefined ? b.mark : ''}</td>
            </tr>
            <tr>
              <td colspan='4' style='padding: 10px; background-color: #f8fafc; font-size: 12px; color: #475569; border-bottom: 2px solid #e2e8f0;'>
                <div style='line-height: 1.5;'>
                  <strong>الشرح والتقييم بالفراغ:</strong> ${b.explanation || ''} ${b.modelAnswer ? `<br><strong style="color: #2563eb;">الإجابة النموذجية:</strong> ${b.modelAnswer}` : ''}
                </div>
              </td>
            </tr>
        `;
    });

    return `
    <div class='ai-evaluation-wrapper' style='background-color: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px; padding: 20px; direction: rtl; text-align: right; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05); margin-top: 15px;'>
      <div style='display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #e2e8f0; padding-bottom: 12px; margin-bottom: 15px;'>
        <span style='font-size: 15px; font-weight: 700; color: #0f172a;'>التقييم والعلامة (${ratingLevel}): <span style='color: #2563eb;'>${userMark} / ${maxMark}</span></span>
        <span style='display: inline-flex; gap: 3px; font-size: 18px;'>${starsHtml}</span>
      </div>
      ${blanks.length > 0 ? `
      <table style='width: 100%; border-collapse: collapse; margin: 15px 0; background-color: #ffffff; border-radius: 8px; overflow: hidden; border: 1px solid #e2e8f0;'>
        <thead>
          <tr style='background-color: #f1f5f9; color: #475569;'>
            <th style='padding: 10px; font-weight: 600; text-align: right; border-bottom: 2px solid #e2e8f0; font-size: 13px;'>الفراغ والسياق</th>
            <th style='padding: 10px; font-weight: 600; text-align: right; border-bottom: 2px solid #e2e8f0; font-size: 13px;'>إجابة الطالب</th>
            <th style='padding: 10px; font-weight: 600; text-align: right; border-bottom: 2px solid #e2e8f0; font-size: 13px;'>التقييم</th>
            <th style='padding: 10px; font-weight: 600; text-align: right; border-bottom: 2px solid #e2e8f0; font-size: 13px;'>العلامة</th>
          </tr>
        </thead>
        <tbody>
          ${blanksRowsHtml}
        </tbody>
      </table>` : ''}
      ${summaryAdvice ? `
      <div style='background-color: #eff6ff; border-right: 4px solid #3b82f6; border-radius: 8px; padding: 15px; margin-top: 15px;'>
        <h6 style='color: #1e40af; margin: 0 0 8px 0; font-size: 14px; font-weight: 700;'><i class='fas fa-info-circle' style='margin-left: 6px;'></i>الخلاصة والتوجيه التربوي</h6>
        <p style='margin: 0; font-size: 13px; color: #1e3a8a;'>${summaryAdvice}</p>
      </div>` : ''}
    </div>`;
};

class FillTextView extends React.Component {

    state = {
        CustomStyle: configData.CustomStyle,
        answers: [],
        answersList: [],
        position: {
            x: 0,
            y: 0
        },
        designerContainer: 100,
        timerSeconds: 0,
        showStats: false,
        aiStats: null,
        fullscreenMessageHtml: null,
        fullscreenMessageQuestion: null,
        mark: {
            type: '',
            userMark: 0,
            isSolved: false
        }
    };

    constructor(props) {
        super(props)
        this.designerContainer = React.createRef();
    }

    handleKeyDown = (e) => {
        if (e.key === "Escape") {
            if (this.state.fullscreenMessageHtml) {
                this.setState({ fullscreenMessageHtml: null, fullscreenMessageQuestion: null });
            }
        }
    };

    handleDownloadResult = (htmlContent, question = "") => {
        let safeQuestion = question
            ? question.replace(/[\\/:*?"<>|]/g, "").trim().substring(0, 50)
            : "اجابة_المساعد";
        if (!safeQuestion) safeQuestion = "اجابة_المساعد";

        const now = new Date();
        const dateStr = now.getFullYear() + "-" +
            String(now.getMonth() + 1).padStart(2, '0') + "-" +
            String(now.getDate()).padStart(2, '0') + "_" +
            String(now.getHours()).padStart(2, '0') + "-" +
            String(now.getMinutes()).padStart(2, '0') + "-" +
            String(now.getSeconds()).padStart(2, '0');

        const filename = `${safeQuestion}_${dateStr}.html`;

        const element = document.createElement("a");
        const file = new Blob([`
            <!DOCTYPE html>
            <html lang="ar" dir="rtl">
            <head>
                <meta charset="utf-8">
                <title>إجابة مساعد الذكاء الاصطناعي</title>
                <link rel="preconnect" href="https://fonts.googleapis.com">
                <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
                <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;600;700&family=Droid+Arabic+Naskh:wght@400;700&display=swap" rel="stylesheet">
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">
                <style>
                    body {
                        font-family: 'Cairo', 'Droid Arabic Naskh', Arial, sans-serif;
                        padding: 30px;
                        background-color: #fdfaf5;
                        color: #0e2c53;
                        line-height: 1.8;
                    }
                    table {
                        width: 100%;
                        border-collapse: collapse;
                        margin: 20px 0;
                    }
                    th, td {
                        padding: 12px 15px;
                        text-align: right;
                        border-bottom: 1px solid #ebd9c5;
                    }
                    th {
                        background-color: #0e2c53;
                        color: white;
                    }
                    tr:nth-child(even) {
                        background-color: #fbf6ee;
                    }
                    a {
                        display: inline-block;
                        background-color: #3b82f6;
                        color: white;
                        padding: 10px 20px;
                        margin: 5px;
                        border-radius: 8px;
                        text-decoration: none;
                        font-weight: bold;
                    }
                </style>
            </head>
            <body>
                ${htmlContent}
            </body>
            </html>
        `], { type: 'text/html' });
        element.href = URL.createObjectURL(file);
        element.download = filename;
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    };

    componentDidMount() {
        if (this.props.setQuestionDesignerContainer) {
            this.props.setQuestionDesignerContainer(this.designerContainer.current.offsetWidth);
        }
        this.setState({
            designerContainer: this.designerContainer.current.offsetWidth
        });
        window.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount() {
        if (this.aiTimerInterval) {
            clearInterval(this.aiTimerInterval);
        }
        window.removeEventListener("keydown", this.handleKeyDown);
    }

    static getDerivedStateFromProps(props, state) {
        state.CustomStyle = { ...props.CustomStyle };
        state.answers = props.answers;
        state.categories = props.categories;
        state.QuestionId = props.Id;

        let answerList = [];
        if (state.answers) {
            state.answers.forEach((item) => {
                let pos = null;
                if (state.CustomStyle.answerPosition && Object.keys(state.CustomStyle.answerPosition).length !== 0) {
                    pos = state.CustomStyle.answerPosition.filter(a => a.Id === item.Id)[0];
                }
                answerList.push({
                    ...item,
                    Position: { ...pos }
                });
            });
        }
        state.answers = answerList;

        let fills = [];
        if (props.fills) {
            props.fills.forEach((node) => {
                const hasAnswer = answerList.filter(p => node.AnswerId === p.Id)[0];
                if (hasAnswer) {
                    const hasCategory = state.categories.filter(p => node.CategoryId === p.Id)[0];
                    if (hasCategory) {
                        fills.push(node);
                    }
                }
            });
        }
        state.fills = fills;

        if (props.onEdit === true && props.fills) {
            state.answersList = fills;
        }

        if (props.onEdit === true && props.categories) {
            let trueAnswer = [];
            props.categories.forEach(category => {
                category.CustomStyle?.Answers.forEach(answer => {
                    var result = { ...answer };
                    result.Sort += 1;
                    trueAnswer.push(result);
                });
            });
            state.answersList = trueAnswer;
        }

        if (props.onEdit === true && props.TypeId === 34 && props.Fills) {
            let trueAnswer = [];
            props.categories.forEach(item => {
                const count = item.Name.split("(_)").length - 1;
                for (let index = 1; index <= count; index++) {
                    const listOfTrueAnswersForThisField = props.Fills.filter(p => p.Sort === index && p.CategoryId === item.Id);
                    const listOfTrueAnswersForThisFieldByName = state.answers.filter(p => listOfTrueAnswersForThisField.some(c => c.AnswerId === p.Id))[0];
                    if (listOfTrueAnswersForThisFieldByName) {
                        trueAnswer.push({
                            Id: item.Id,
                            Answer: listOfTrueAnswersForThisFieldByName.Name,
                            Sort: index
                        });
                    }
                }
            });
            state.answersList = trueAnswer;
        }

        if (props.examAnswers) {
            const hasAnswer = props.examAnswers.filter(p => p.Id === props.Id)[0];
            if (hasAnswer) {
                state.answersList = hasAnswer.answers;
                if ((props.TypeId === 33) && hasAnswer.answers && hasAnswer.answers.length > 0 && hasAnswer.answers[0].note) {
                    state.aiStreamAnswer = hasAnswer.answers[0].note;
                    state.mark = {
                        isSolved: true,
                        type: hasAnswer.mark >= props.mark ? 'success' : (hasAnswer.mark > 0 ? 'warning' : 'danger'),
                        userMark: hasAnswer.mark,
                        title: hasAnswer.mark >= props.mark ? props.t('Pages.Lessons.Questions.forms.Options.success.Title') : props.t('Pages.Lessons.Questions.forms.Options.error.Title'),
                        text: hasAnswer.mark >= props.mark ? props.t('Pages.Lessons.Questions.forms.Options.success.Answers') : props.t('Pages.Lessons.Questions.forms.Options.error.Answers')
                    };
                }
            } else if (props.showResult) {
                const { t } = props;
                state.mark = {
                    type: 'danger',
                    userMark: 0,
                    isSolved: true,
                    text: t('Pages.Lessons.Questions.forms.Options.error.NoAnswers'),
                    title: props.isExamQuestion === true ? t('Pages.Lessons.Questions.forms.Options.error.ForExam') : t('Pages.Lessons.Questions.forms.Options.error.Title')
                };
            }
        }
        return state;
    }

    renderCategories() {
        if (this.state.categories) {
            const length = this.state.categories.length;
            let AnswersMargin = 0;
            if (this.state.CustomStyle.questionTypeStyle && this.state.CustomStyle.questionTypeStyle.AnswersMargin) {
                AnswersMargin = this.state.CustomStyle.questionTypeStyle.AnswersMargin;
            }
            return (
                <div className={`row row-cols-1`} style={{
                    height: '100%',
                    position: 'relative'
                }}>
                    {
                        this.state.categories.sort((a, b) => a.Sort - b.Sort).map((item, index) => {
                            if (index + 1 === length) {
                                AnswersMargin = 0;
                            }
                            return (
                                <div className={`col mb-${AnswersMargin}`} key={item.Id}>
                                    {this.renderTextFiled(item)}
                                </div>
                            )
                        })
                    }
                </div >
            );
        }
        return "";
    }

    renderControlButton() {
        const { t, solveButton, showResult } = this.props;
        if (solveButton) {
            return (
                <>
                    {showResult !== true ? this.renderMark() : ""}
                    <div className="w-100 mt-3 d-flex justify-content-around">
                        <button className="btn btn-success mx-3" title={t('Pages.Lessons.Questions.forms.Options.CheckAnswer')} onClick={() => this.CheckAnswer()}>
                            <i className="icon fas fa-badge-check"></i> {t('Pages.Lessons.Questions.forms.Options.CheckAnswer')}
                        </button>
                        <button className="btn btn-dark mx-3" title={t('Pages.Lessons.Questions.forms.Options.ResetAnswer')} onClick={() => this.ResetAnswer()}>
                            <i className="icon fas fa-repeat-alt"></i> {t('Pages.Lessons.Questions.forms.Options.ResetAnswer')}
                        </button>
                    </div>
                </>
            );
        } else if (showResult) {
            return (
                <>
                    {this.renderMark()}
                </>
            );
        }
        return "";
    }

    ResetAnswer = () => {
        this.state.categories.sort((a, b) => a.Sort - b.Sort).forEach(item => {
            const count = item.Name.split("(_)").length - 1;
            for (let index = 1; index <= count; index++) {
                document.getElementById(`TextFiledAnswer-${item.Id}-${index}`).value = "";
            }
        });
        this.setState({
            answersList: [],
            aiStats: null,
            showStats: false,
            mark: {
                type: '',
                userMark: 0,
                isSolved: false
            }
        });

    }

    getDifference(a, b) {
        var i = 0;
        var j = 0;
        var result = "";

        while (j < b.length) {
            if (a[i] !== b[j] || i === a.length)
                result += b[j];
            else
                i++;
            j++;
        }
        return result;
    }

    CheckAnswer = async () => {
        const { t, mark, toast, TypeId, Id } = this.props;
        const {
            trueAnswers,
            trueAnswer,
            falseAnswer,
            answersCount,
            answersList } = this.GetAnswerList();

        if (answersCount === 0) {
            let _toastId = toast(t('Processing'), {
                position: "bottom-left",
                autoClose: false
            });
            toast.update(_toastId, {
                render: () => <div><div className="h5"> <i className="icon fal fa-lightbulb-on"></i> {t('Pages.Lessons.Questions.forms.Options.error.NoAnswer.Title')}</div> <div className="h6">{t('Pages.Lessons.Questions.forms.Options.error.NoAnswer.Body')}</div></div>,
                type: toast.TYPE.ERROR,
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } else if (TypeId === 4 || TypeId === 34) {

            if (trueAnswers === trueAnswer) {
                this.setState({
                    answersList,
                    mark: {
                        type: 'success',
                        userMark: mark,
                        isSolved: true,
                        text: t('Pages.Lessons.Questions.forms.Options.success.Answers'),
                        title: t('Pages.Lessons.Questions.forms.Options.success.Title')
                    }
                });
                this.props.playTrueSound();
                this.props.showConfetti();
            } else if (falseAnswer > trueAnswer) {
                this.setState({
                    answersList,
                    mark: {
                        type: 'danger',
                        userMark: (mark * trueAnswer / trueAnswers).toFixed(2),
                        isSolved: true,
                        text: t('Pages.Lessons.Questions.forms.Options.error.Answers'),
                        title: this.props.isExamQuestion === true ? t('Pages.Lessons.Questions.forms.Options.error.ForExam') : t('Pages.Lessons.Questions.forms.Options.error.Title')
                    }
                });
                this.props.playFalseSound();
            } else {
                this.setState({
                    answersList,
                    mark: {
                        type: 'warning',
                        userMark: (mark * trueAnswer / trueAnswers).toFixed(2),
                        isSolved: true,
                        text: t('Pages.Lessons.Questions.forms.Options.error.Answers'),
                        title: this.props.isExamQuestion === true ? t('Pages.Lessons.Questions.forms.Options.error.ForExam') : t('Pages.Lessons.Questions.forms.Options.error.Title')

                    }
                });
                this.props.playFalseSound();
            }
        } else if (TypeId === 33) {

            let _toastId = toast(t('Processing'), {
                position: "bottom-left",
                autoClose: false
            });

            this.setState({
                aiStreamAnswer: '',
                timerSeconds: 0,
                answersList,
                mark: {
                    isSolved: true,
                    type: 'info',
                    title: t('Pages.Lessons.Questions.forms.Options.ai.title', 'جاري التقييم بواسطة الذكاء الاصطناعي...'),
                    text: t('Pages.Lessons.Questions.forms.Options.ai.text', 'يقوم المساعد الذكي بتقييم إجابتك حالياً، يرجى الانتظار...'),
                    userMark: 0
                }
            });

            this.aiTimerInterval = setInterval(() => {
                this.setState(prevState => ({
                    timerSeconds: prevState.timerSeconds + 1
                }));
            }, 1000);

            try {
                const baseUrl = process.env.REACT_APP_BASE_URL || 'https://alarabeyya.com/api';
                const response = await fetch(`${baseUrl}/CheckQuestionAnswer/${Id}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${getToken()}`,
                        'timeZone': Intl.DateTimeFormat().resolvedOptions().timeZone,
                        'TimezoneOffset': - new Date().getTimezoneOffset()
                    },
                    body: JSON.stringify({ Answers: answersList })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const reader = response.body.getReader();
                const decoder = new TextDecoder('utf-8');
                let buffer = '';
                let aiStreamAnswer = '';
                let blanks = null;
                let userMark = 0;
                let databaseTimeMs = null;
                let apiTimeMs = null;
                let sendTimeMs = null;
                let responseTimeMs = null;
                let serverTimeMs = null;
                let sendTokens = null;
                let receivedTokens = null;
                let bandwidth = null;
                let sendTokensDetails = null;
                let model = null;
                let price = null;
                let isFromCache = false;

                while (true) {
                    const { value, done } = await reader.read();
                    if (done) break;

                    buffer += decoder.decode(value, { stream: true });
                    const lines = buffer.split('\n');
                    buffer = lines.pop();

                    for (const line of lines) {
                        const trimmed = line.trim();
                        if (!trimmed) continue;

                        let jsonStr = trimmed;
                        if (trimmed.startsWith('data:')) {
                            jsonStr = trimmed.slice(5).trim();
                        }

                        try {
                            const parsed = JSON.parse(jsonStr);
                            if (parsed.Answer) {
                                if (this.aiTimerInterval) {
                                    clearInterval(this.aiTimerInterval);
                                    this.aiTimerInterval = null;
                                }
                                aiStreamAnswer += parsed.Answer;
                                this.setState({ aiStreamAnswer });
                            }
                            if (parsed.Status === 'done') {
                                blanks = parsed.Blanks;
                                userMark = parsed.UserMark;
                                databaseTimeMs = parsed.DatabaseTimeMs;
                                apiTimeMs = parsed.ApiTimeMs;
                                sendTimeMs = parsed.SendTimeMs;
                                responseTimeMs = parsed.ResponseTimeMs;
                                serverTimeMs = parsed.ServerTimeMs;
                                sendTokens = parsed.SendTokens;
                                receivedTokens = parsed.ReceivedTokens;
                                bandwidth = parsed.Bandwidth;
                                sendTokensDetails = parsed.SendTokensDetails ? {
                                    systemInstruction: parsed.SendTokensDetails.SystemInstruction !== undefined ? parsed.SendTokensDetails.SystemInstruction : parsed.SendTokensDetails.systemInstruction,
                                    context: parsed.SendTokensDetails.Context !== undefined ? parsed.SendTokensDetails.Context : parsed.SendTokensDetails.context,
                                    lessonsList: parsed.SendTokensDetails.LessonsList !== undefined ? parsed.SendTokensDetails.LessonsList : parsed.SendTokensDetails.lessonsList,
                                    question: parsed.SendTokensDetails.Question !== undefined ? parsed.SendTokensDetails.Question : parsed.SendTokensDetails.question
                                } : undefined;
                                model = parsed.Model || parsed.model;
                                price = parsed.Price !== undefined ? parsed.Price : parsed.price;
                                isFromCache = parsed.IsFromCache !== undefined ? parsed.IsFromCache : parsed.isFromCache;
                            }
                        } catch (e) {
                            console.warn('Could not parse SSE JSON line', line, e);
                        }
                    }
                }

                if (buffer && buffer.trim()) {
                    const trimmed = buffer.trim();
                    let jsonStr = trimmed;
                    if (trimmed.startsWith('data:')) {
                        jsonStr = trimmed.slice(5).trim();
                    }
                    try {
                        const parsed = JSON.parse(jsonStr);
                        if (parsed.Answer) {
                            if (this.aiTimerInterval) {
                                clearInterval(this.aiTimerInterval);
                                this.aiTimerInterval = null;
                            }
                            aiStreamAnswer += parsed.Answer;
                            this.setState({ aiStreamAnswer });
                        }
                        if (parsed.Status === 'done') {
                            blanks = parsed.Blanks;
                            userMark = parsed.UserMark;
                            databaseTimeMs = parsed.DatabaseTimeMs;
                            apiTimeMs = parsed.ApiTimeMs;
                            sendTimeMs = parsed.SendTimeMs;
                            responseTimeMs = parsed.ResponseTimeMs;
                            serverTimeMs = parsed.ServerTimeMs;
                            sendTokens = parsed.SendTokens;
                            receivedTokens = parsed.ReceivedTokens;
                            bandwidth = parsed.Bandwidth;
                            sendTokensDetails = parsed.SendTokensDetails ? {
                                systemInstruction: parsed.SendTokensDetails.SystemInstruction !== undefined ? parsed.SendTokensDetails.SystemInstruction : parsed.SendTokensDetails.systemInstruction,
                                context: parsed.SendTokensDetails.Context !== undefined ? parsed.SendTokensDetails.Context : parsed.SendTokensDetails.context,
                                lessonsList: parsed.SendTokensDetails.LessonsList !== undefined ? parsed.SendTokensDetails.LessonsList : parsed.SendTokensDetails.lessonsList,
                                question: parsed.SendTokensDetails.Question !== undefined ? parsed.SendTokensDetails.Question : parsed.SendTokensDetails.question
                            } : undefined;
                            model = parsed.Model || parsed.model;
                            price = parsed.Price !== undefined ? parsed.Price : parsed.price;
                            isFromCache = parsed.IsFromCache !== undefined ? parsed.IsFromCache : parsed.isFromCache;
                        }
                    } catch (e) {
                        console.warn('Could not parse remaining buffer JSON', buffer, e);
                    }
                }

                let aiStatsObj = null;
                if (databaseTimeMs !== null || apiTimeMs !== null) {
                    aiStatsObj = {
                        databaseTimeMs,
                        apiTimeMs,
                        sendTimeMs,
                        responseTimeMs,
                        serverTimeMs,
                        sendTokens,
                        receivedTokens,
                        bandwidth,
                        sendTokensDetails,
                        model,
                        price,
                        isFromCache
                    };
                }

                toast.dismiss(_toastId);

                let userMarkFloat = parseFloat(userMark);
                if (isNaN(userMarkFloat)) {
                    userMarkFloat = 0;
                }

                let answersListCorrect = [];
                answersList.forEach((item, index) => {
                    const isBlankCorrect = (blanks && blanks[index] !== undefined) ? blanks[index] : false;
                    answersListCorrect.push({
                        ...item,
                        isTrue: isBlankCorrect,
                        note: index === 0 ? aiStreamAnswer : '',
                        mark: isBlankCorrect ? (mark / trueAnswers) : 0
                    });
                });

                let trueAnswerCount = answersListCorrect.filter(a => a.isTrue).length;
                let falseAnswerCount = trueAnswers - trueAnswerCount;
                let isCorrect = trueAnswerCount === trueAnswers;

                if (this.props.saveExamAnswer) {
                    this.props.saveExamAnswer(this.props.Id, this.props.TypeId, answersListCorrect, {
                        trueResultCount: trueAnswers,
                        trueAnswer: trueAnswerCount,
                        falseAnswer: falseAnswerCount,
                        questionMark: this.props.mark
                    }, userMarkFloat);
                }

                if (isCorrect) {
                    this.setState({
                        answersListCorrect,
                        answersList: answersListCorrect,
                        userMark: userMarkFloat,
                        aiStats: aiStatsObj,
                        mark: {
                            type: 'success',
                            userMark: userMarkFloat,
                            isSolved: true,
                            text: t('Pages.Lessons.Questions.forms.Options.success.Answers'),
                            title: t('Pages.Lessons.Questions.forms.Options.success.Title')
                        }
                    });
                    this.props.playTrueSound();
                    this.props.showConfetti();
                } else if (userMarkFloat > 0) {
                    this.setState({
                        answersListCorrect,
                        answersList: answersListCorrect,
                        userMark: userMarkFloat,
                        aiStats: aiStatsObj,
                        mark: {
                            type: 'warning',
                            userMark: userMarkFloat,
                            isSolved: true,
                            text: t('Pages.Lessons.Questions.forms.Options.error.Answers'),
                            title: this.props.isExamQuestion === true ? t('Pages.Lessons.Questions.forms.Options.error.ForExam') : t('Pages.Lessons.Questions.forms.Options.error.Title')
                        }
                    });
                    this.props.playFalseSound();
                } else {
                    this.setState({
                        answersListCorrect,
                        answersList: answersListCorrect,
                        userMark: userMarkFloat,
                        aiStats: aiStatsObj,
                        mark: {
                            type: 'danger',
                            userMark: userMarkFloat,
                            isSolved: true,
                            text: t('Pages.Lessons.Questions.forms.Options.error.Answers'),
                            title: this.props.isExamQuestion === true ? t('Pages.Lessons.Questions.forms.Options.error.ForExam') : t('Pages.Lessons.Questions.forms.Options.error.Title')
                        }
                    });
                    this.props.playFalseSound();
                }

            } catch (error) {
                toast.update(_toastId, {
                    render: () => <div><div className="h5"> <i className="icon fal fa-wifi-slash"></i> {t('Error.NoConnection.Title')}</div> <div className="h6">{t('Error.NoConnection.Body')}</div></div>,
                    type: toast.TYPE.ERROR,
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } finally {
                if (this.aiTimerInterval) {
                    clearInterval(this.aiTimerInterval);
                }
            }
        }
    }

    GetAnswerList = () => {
        let trueAnswer = 0;
        let falseAnswer = 0;
        let trueAnswers = 0;
        let answersCount = 0;
        let answersList = [];
        this.state.categories.sort((a, b) => a.Sort - b.Sort).forEach(item => {
            const CustomStyle = item.CustomStyle;
            const count = item.Name.split("(_)").length - 1;
            trueAnswers += count;
            for (let index = 1; index <= count; index++) {
                let userAnswer = document.getElementById(`TextFiledAnswer-${item.Id}-${index}`).value.trim();
                if (userAnswer) {
                    let newAnswer =
                    {
                        Id: item.Id,
                        Sort: index,
                        Answer: userAnswer,
                        TrueAnswer: "",
                        isTrue: false
                    }

                    if (CustomStyle.Answers) {
                        const answer = CustomStyle.Answers.filter(p => p.Id === item.Id && p.Sort === index - 1)[0];

                        if (answer.IsChecked === true) {
                            userAnswer = userAnswer.replace(/([ًٌٍَُِّْ])/g, "");
                        }
                        if (answer.HamzaIsChecked === true) {
                            userAnswer = userAnswer.replace(/([أإ])/g, "ا");
                        }

                        if (this.props.TypeId === 4) {
                            if (answer && answer.Answer) {
                                if (answer.IsChecked === true) {
                                    userAnswer = userAnswer.replace(/([ًٌٍَُِّْ])/g, "");
                                    answer.Answer = answer.Answer.replace(/([ًٌٍَُِّْ])/g, "");
                                }
                                if (answer.HamzaIsChecked === true) {
                                    userAnswer = userAnswer.replace(/([أإ])/g, "ا");
                                    answer.Answer = answer.Answer.replace(/([أإ])/g, "ا");
                                }

                                newAnswer.TrueAnswer = answer.Answer;

                                let diffrent = this.getDifference(userAnswer, answer.Answer);
                                let rate = (diffrent.length / answer.Answer.length * 100).toFixed(0);

                                if (rate >= 100 || (100 - rate) < answer.Percentage) {
                                    falseAnswer++;
                                } else {
                                    diffrent = this.getDifference(answer.Answer, userAnswer);
                                    rate = (diffrent.length / answer.Answer.length * 100).toFixed(0);
                                    if (rate >= 100 || (100 - rate) < answer.Percentage) {
                                        falseAnswer++;
                                    } else {
                                        trueAnswer++;
                                        newAnswer.isTrue = true;
                                    }
                                }
                            }
                        } else if (this.props.TypeId === 34) {
                            const listOfTrueAnswersForThisField = this.state.fills.filter(p => p.Sort === index && p.CategoryId === item.Id);
                            const listOfTrueAnswersForThisFieldByName = this.state.answers.filter(p => listOfTrueAnswersForThisField.some(c => c.AnswerId === p.Id));

                            let localIsTrue = false;
                            listOfTrueAnswersForThisFieldByName.forEach(itemTrueAnswer => {
                                let itemTrueAnswerName = itemTrueAnswer.Name.trim();
                                if (answer.IsChecked === true) {
                                    itemTrueAnswerName = itemTrueAnswerName.replace(/([ًٌٍَُِّْ])/g, "");
                                }
                                if (answer.HamzaIsChecked === true) {
                                    itemTrueAnswerName = itemTrueAnswerName.replace(/([أإ])/g, "ا");
                                }
                                newAnswer.TrueAnswer = itemTrueAnswerName;

                                let diffrent = this.getDifference(userAnswer, itemTrueAnswerName);
                                let rate = (diffrent.length / itemTrueAnswerName.length * 100).toFixed(0);

                                if (rate >= 100 || (100 - rate) < answer.Percentage) {
                                    return;
                                } else {
                                    diffrent = this.getDifference(itemTrueAnswerName, userAnswer);
                                    rate = (diffrent.length / itemTrueAnswerName.length * 100).toFixed(0);
                                    if (rate >= 100 || (100 - rate) < answer.Percentage) {
                                        return;
                                    } else {
                                        localIsTrue = true;
                                    }
                                }
                            });
                            if (localIsTrue) {
                                trueAnswer++;
                                newAnswer.isTrue = true;
                            } else {
                                falseAnswer++;
                            }
                        }

                        if (this.props.TypeId === 33) {
                            if (answer && answer.Answer) {
                                newAnswer.TrueAnswer = answer.Answer;
                            }
                            newAnswer.model = (answer && answer.model) ? answer.model : "deepseek";
                        }

                        answersCount++;
                    }

                    answersList.push(newAnswer);
                } else {
                    falseAnswer++;
                }
            }
        });

        let userMark = 0;
        const mark = this.props.mark
        if (trueAnswers === trueAnswer) {
            userMark = mark;
        } else {
            userMark = (mark * trueAnswer / trueAnswers).toFixed(2);
        }

        return {
            trueAnswers,
            answersCount,
            trueAnswer,
            falseAnswer,
            answersList,
            userMark
        };
    }

    renderAiEvaluationCard(evalObj) {
        if (!evalObj) return null;
        const userMark = evalObj.userMark !== undefined ? evalObj.userMark : 0;
        const maxMark = evalObj.maxMark !== undefined ? evalObj.maxMark : (this.props.mark || 10);
        const ratingLevel = evalObj.ratingLevel || "تقييم الإجابة";
        const starsCount = evalObj.starsCount !== undefined ? evalObj.starsCount : Math.min(5, Math.max(0, (userMark / (maxMark || 1)) * 5));
        const blanks = evalObj.blanks || [];
        const summaryAdvice = evalObj.summaryAdvice || "";

        const filledStars = Math.floor(starsCount);
        const hasHalfStar = (starsCount - filledStars) >= 0.25 && (starsCount - filledStars) <= 0.75;
        const emptyStars = Math.max(0, 5 - filledStars - (hasHalfStar ? 1 : 0));

        return (
            <div className="ai-evaluation-card my-3 p-3 rounded" style={{ backgroundColor: "#f8fafc", border: "1px solid #e2e8f0", boxShadow: "0 4px 6px rgba(0,0,0,0.05)", direction: "rtl", textAlign: "right" }}>
                <div className="d-flex align-items-center justify-content-between pb-2 mb-3" style={{ borderBottom: "1px solid #e2e8f0" }}>
                    <span style={{ fontSize: "15px", fontWeight: "700", color: "#0f172a" }}>
                        التقييم والعلامة ({ratingLevel}): <span className="text-primary">{userMark} / {maxMark}</span>
                    </span>
                    <span className="d-inline-flex gap-1" style={{ fontSize: "18px" }}>
                        {Array.from({ length: filledStars }).map((_, i) => (
                            <i key={`f-${i}`} className="fas fa-star" style={{ color: "#fbbf24", marginLeft: "2px" }}></i>
                        ))}
                        {hasHalfStar && (
                            <i className="fas fa-star-half-alt" style={{ color: "#fbbf24", transform: "scaleX(-1)", display: "inline-block", marginLeft: "2px" }}></i>
                        )}
                        {Array.from({ length: emptyStars }).map((_, i) => (
                            <i key={`e-${i}`} className="far fa-star" style={{ color: "#cbd5e1", marginLeft: "2px" }}></i>
                        ))}
                    </span>
                </div>

                {blanks.length > 0 && (
                    <div className="table-responsive">
                        <table className="table table-bordered bg-white mb-3" style={{ borderRadius: "8px", overflow: "hidden" }}>
                            <thead>
                                <tr style={{ backgroundColor: "#f1f5f9", color: "#475569" }}>
                                    <th style={{ padding: "10px", fontSize: "13px" }}>الفراغ والسياق</th>
                                    <th style={{ padding: "10px", fontSize: "13px" }}>إجابة الطالب</th>
                                    <th style={{ padding: "10px", fontSize: "13px" }}>التقييم</th>
                                    <th style={{ padding: "10px", fontSize: "13px" }}>العلامة</th>
                                </tr>
                            </thead>
                            <tbody>
                                {blanks.map((b, idx) => {
                                    const isCorrect = b.status === "correct" || b.isCorrect;
                                    const isPartial = b.status === "partial";
                                    return (
                                        <React.Fragment key={idx}>
                                            <tr style={{ borderBottom: "1px solid #f1f5f9" }}>
                                                <td style={{ padding: "10px", color: "#1e293b", fontSize: "13px", fontWeight: "600" }}>{b.context}</td>
                                                <td style={{ padding: "10px", color: "#334155", fontSize: "13px" }}>{b.studentAnswer}</td>
                                                <td style={{ padding: "10px", fontSize: "13px" }}>
                                                    {isCorrect ? (
                                                        <span className="badge badge-success p-2"><i className="fas fa-check-circle ml-1"></i> إجابة صحيحة</span>
                                                    ) : isPartial ? (
                                                        <span className="badge badge-warning p-2"><i className="fas fa-exclamation-triangle ml-1"></i> إجابة ناقصة</span>
                                                    ) : (
                                                        <span className="badge badge-danger p-2"><i className="fas fa-times-circle ml-1"></i> غير صحيحة</span>
                                                    )}
                                                </td>
                                                <td style={{ padding: "10px", fontWeight: "bold", fontSize: "13px" }}>{b.mark !== undefined ? b.mark : ""}</td>
                                            </tr>
                                            <tr>
                                                <td colSpan="4" style={{ padding: "10px", backgroundColor: "#f8fafc", fontSize: "12px", color: "#475569", borderBottom: "2px solid #e2e8f0" }}>
                                                    <div style={{ lineHeight: "1.6" }}>
                                                        <strong>الشرح والتقييم بالفراغ:</strong> {b.explanation}
                                                        {b.modelAnswer && (
                                                            <div className="mt-1 text-primary">
                                                                <strong>الإجابة النموذجية:</strong> {b.modelAnswer}
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}

                {summaryAdvice && (
                    <div className="p-3 rounded" style={{ backgroundColor: "#eff6ff", borderRight: "4px solid #3b82f6" }}>
                        <h6 style={{ color: "#1e40af", margin: "0 0 6px 0", fontSize: "14px", fontWeight: "700" }}>
                            <i className="fas fa-info-circle ml-2"></i>الخلاصة والتوجيه التربوي
                        </h6>
                        <p style={{ margin: 0, fontSize: "13px", color: "#1e3a8a", lineHeight: "1.6" }}>{summaryAdvice}</p>
                    </div>
                )}
            </div>
        );
    }

    renderMark() {
        const { t, showResult, TypeId } = this.props;
        if (this.state.mark.isSolved) {
            let evalObj = this.state.aiEvaluationObj;
            if (!evalObj && this.state.aiStreamAnswer) {
                try {
                    evalObj = JSON.parse(this.state.aiStreamAnswer);
                } catch (e) { }
            }

            let evalHtml = '';
            if (evalObj) {
                evalHtml = convertEvaluationJsonToHtml(evalObj);
            } else if (this.state.aiStreamAnswer) {
                evalHtml = this.state.aiStreamAnswer;
            }

            return (
                <>
                    <div className={`alert mt-4 h5 p-3 alert-${this.state.mark.type}`} role="alert">
                        <h5 className="alert-heading"> <i className="icon fal fa-lightbulb-on"></i>{this.state.mark.title}</h5>
                        {this.state.mark.text}
                        {this.state.mark.type === 'info' && (
                            <div className="d-flex align-items-center mt-3">
                                <div className="spinner-border text-info mx-3" role="status" style={{ width: '1.5rem', height: '1.5rem', borderWidth: '0.2em' }}></div>
                                <span className="h6 mb-0">
                                    {t('Pages.Lessons.Questions.forms.Options.ai.timer', 'يرجى الانتظار (يتبقى __seconds__ ثانية)...').replace('__seconds__', this.state.timerSeconds || 0)}
                                </span>
                            </div>
                        )}
                        {
                            (TypeId === 33) ? (
                                evalObj ? (
                                    this.renderAiEvaluationCard(evalObj)
                                ) : (
                                    this.state.aiStreamAnswer ? (
                                        <div className="ai-stream-evaluation my-3 text-right" dangerouslySetInnerHTML={{ __html: this.state.aiStreamAnswer }} />
                                    ) : ""
                                )
                            ) : ""
                        }
                        {
                            (TypeId === 33 && (evalObj || this.state.aiStreamAnswer)) ? (
                                <div className="bot-bubble-actions-row my-3" style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                    {this.state.aiStats && (
                                        <div
                                            className="stats-badge total-time-badge"
                                            onClick={() => this.setState(prev => ({ showStats: !prev.showStats }))}
                                            role="button"
                                            style={{ cursor: 'pointer', gap: '8px' }}
                                        >
                                            <i className="fal fa-robot"></i>
                                            <span style={{ textTransform: 'capitalize', fontWeight: 'bold' }}>
                                                {this.state.aiStats.model || this.state.aiStats.Model || 'deepseek'}
                                            </span>
                                            <span style={{ opacity: 0.3 }}>|</span>
                                            <i className="fal fa-clock"></i>
                                            <span>
                                                {t("Pages.Chatbot.TotalTime") || "وقت الاستجابة الكلي"}: {(((this.state.aiStats.databaseTimeMs || 0) + (this.state.aiStats.apiTimeMs || 0)) / 1000).toFixed(2)} {t("Pages.Chatbot.Sec") || "ثانية"}
                                            </span>
                                        </div>
                                    )}
                                    <div className="bot-bubble-actions" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                        <button
                                            type="button"
                                            className="fullscreen-expand-btn"
                                            onClick={() => this.setState({
                                                fullscreenMessageHtml: evalHtml,
                                                fullscreenMessageQuestion: this.props.title || ""
                                            })}
                                            title={t("Pages.Chatbot.FullScreen") || "ملء الشاشة"}
                                        >
                                            <i className="fal fa-expand-arrows"></i>
                                        </button>
                                        <button
                                            type="button"
                                            className="bubble-download-btn"
                                            onClick={() => this.handleDownloadResult(evalHtml, this.props.title || "")}
                                            title={t("Pages.Chatbot.Download") || "تحميل الإجابة"}
                                        >
                                            <i className="fal fa-download"></i>
                                        </button>
                                    </div>
                                </div>
                            ) : null
                        }
                        <p className="mb-0">{t('Pages.Lessons.Questions.forms.Options.yourMark')} : {this.state.mark.userMark}</p>
                    </div>
                </>
            );
        } else if (showResult) {
            setTimeout(() => {
                const { t, mark } = this.props;
                const {
                    trueAnswers,
                    trueAnswer,
                    falseAnswer
                } = this.GetAnswerList();

                if (trueAnswers === trueAnswer) {
                    this.setState({
                        mark: {
                            type: 'success',
                            userMark: mark,
                            isSolved: true,
                            text: t('Pages.Lessons.Questions.forms.Options.success.Answers'),
                            title: t('Pages.Lessons.Questions.forms.Options.success.Title')
                        }
                    });
                } else if (falseAnswer > trueAnswer) {
                    this.setState({
                        mark: {
                            type: 'danger',
                            userMark: (mark * trueAnswer / trueAnswers).toFixed(2),
                            isSolved: true,
                            text: t('Pages.Lessons.Questions.forms.Options.error.Answers'),
                            title: this.props.isExamQuestion === true ? t('Pages.Lessons.Questions.forms.Options.error.ForExam') : t('Pages.Lessons.Questions.forms.Options.error.Title')
                        }
                    });
                } else {
                    this.setState({
                        mark: {
                            type: 'warning',
                            userMark: (mark * trueAnswer / trueAnswers).toFixed(2),
                            isSolved: true,
                            text: t('Pages.Lessons.Questions.forms.Options.error.Answers'),
                            title: this.props.isExamQuestion === true ? t('Pages.Lessons.Questions.forms.Options.error.ForExam') : t('Pages.Lessons.Questions.forms.Options.error.Title')
                        }
                    });
                }
            }, 500);
        }
        return "";
    }

    renderTextFiled(item) {
        const count = item.Name.split("(_)").length - 1;
        var html = item.Name;
        const CustomStyle = item.CustomStyle;
        for (let index = 0; index < count; index++) {

            let isTrue = "";
            if (this.state.mark.isSolved === true && this.state.mark.type !== 'info') {
                var hasAnswer = this.state.answersList.filter(p => p.Id === item.Id && p.Sort === (index + 1))[0];
                if (hasAnswer && hasAnswer.isTrue) {
                    isTrue = 1;
                } else {
                    isTrue = 0;
                }
            }

            html = html.replace("(_)", `<span version='${this.props.version}' isTrue='${isTrue}'  Sort='${index + 1}' data-react-component="TextFiled"></span>`);
        }
        return <ReactHtml
            html={html}
            handleAnswerChange={this.handleAnswerChange}
            SoundIconType={this.state.CustomStyle.questionTypeStyle.AnswersSelectType}
            SoundIconClass={this.state.CustomStyle.questionTypeStyle.AnswersSelectClass}
            CustomStyle={CustomStyle}
            componentMap={{ TextFiled }}
            CategoryId={item.Id}
            QuestionId={this.state.QuestionId}
            answersList={this.state.answersList} />;
    }

    saveExamAnswer() {
        if (this.props.saveExamAnswer) {
            setTimeout(() => {
                const {
                    trueAnswers,
                    trueAnswer,
                    falseAnswer,
                    answersList,
                    userMark } = this.GetAnswerList();
                this.props.saveExamAnswer(this.props.Id, this.props.TypeId, answersList, {
                    trueResultCount: trueAnswers,
                    trueAnswer,
                    falseAnswer,
                    questionMark: this.props.mark
                }, userMark);
            }, 500);
        }
    }

    handleAnswerChange = () => {
        this.saveExamAnswer();
    }

    render() {
        const { title, mark, index, Id, onEdit, t } = this.props;
        const statsStyles = `
            .stats-badge.total-time-badge {
                cursor: pointer;
                user-select: none;
                display: inline-flex;
                align-items: center;
                gap: 5px;
                background: rgba(146, 39, 143, 0.03);
                border: 1px solid rgba(146, 39, 143, 0.1);
                color: #92278f;
                font-weight: 500;
                transition: all 0.2s ease;
                padding: 5px 10px;
                border-radius: 8px;
                font-size: 12px;
                font-family: "Droid Arabic Naskh", sans-serif;
            }
            .stats-badge.total-time-badge:hover {
                background: rgba(146, 39, 143, 0.07);
                border-color: rgba(146, 39, 143, 0.3);
                transform: translateY(-0.5px);
            }
            .fullscreen-modal-overlay {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: rgba(14, 44, 83, 0.65);
                backdrop-filter: blur(8px);
                -webkit-backdrop-filter: blur(8px);
                z-index: 10000;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 30px;
            }
            .fullscreen-modal-card {
                background: rgba(255, 255, 255, 0.95);
                border: 1px solid rgba(235, 217, 197, 0.6);
                border-radius: 24px;
                width: 100%;
                max-width: 1000px;
                height: 90vh;
                display: flex;
                flex-direction: column;
                box-shadow: 0 30px 60px rgba(14, 44, 83, 0.25);
                overflow: hidden;
            }
            .fullscreen-modal-header {
                padding: 20px 30px;
                border-bottom: 1px solid rgba(235, 217, 197, 0.5);
                display: flex;
                align-items: center;
                justify-content: space-between;
                background-color: #fdfaf5;
            }
            .fullscreen-modal-title {
                margin: 0;
                font-size: 20px;
                font-weight: 700;
                color: #0e2c53;
                display: flex;
                align-items: center;
                gap: 10px;
                font-family: "Droid Arabic Naskh", sans-serif;
            }
            .fullscreen-modal-close-btn {
                background: none;
                border: none;
                color: #ff5200;
                font-size: 24px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.2s ease;
                width: 40px;
                height: 40px;
                border-radius: 50%;
            }
            .fullscreen-modal-close-btn:hover {
                background-color: rgba(255, 82, 0, 0.1);
                transform: scale(1.1);
            }
            .fullscreen-modal-body {
                flex: 1;
                padding: 40px;
                overflow-y: auto;
                text-align: right;
                direction: rtl;
            }
            .bot-bubble-actions-row {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 12px;
                margin-top: 8px;
                width: 100%;
            }
            .bot-bubble-actions {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 8px;
            }
            .fullscreen-expand-btn, .bubble-download-btn {
                background: #ffffff;
                border: 1px solid rgba(235, 217, 197, 0.6);
                color: #8c857b;
                width: 30px;
                height: 30px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                transition: all 0.2s ease;
                box-shadow: 0 2px 5px rgba(14, 44, 83, 0.05);
                outline: none;
                font-size: 13px;
            }
            .fullscreen-expand-btn:hover {
                background: #ffffff;
                color: #92278f;
                border-color: #92278f;
                box-shadow: 0 4px 12px rgba(146, 39, 143, 0.15);
                transform: scale(1.05);
            }
            .bubble-download-btn:hover {
                background: #ffffff;
                color: #8dc63f;
                border-color: #8dc63f;
                box-shadow: 0 4px 12px rgba(141, 198, 63, 0.15);
                transform: scale(1.05);
            }
            .fullscreen-modal-download-btn {
                background: linear-gradient(135deg, #8dc63f 0%, #7bb32d 100%);
                color: #ffffff !important;
                box-shadow: 0 4px 12px rgba(141, 198, 63, 0.25);
                border: none;
                display: inline-flex;
                align-items: center;
                gap: 8px;
                padding: 8px 16px;
                border-radius: 10px;
                font-size: 13px;
                font-weight: 700;
                cursor: pointer;
                transition: all 0.25s ease;
            }
            .fullscreen-modal-download-btn:hover {
                background: linear-gradient(135deg, #7bb32d 0%, #689823 100%);
                box-shadow: 0 6px 16px rgba(141, 198, 63, 0.35);
                transform: translateY(-1px);
            }
        `;
        const SizeView = this.props.SizeView ? this.props.SizeView : 100;

        let style = {
            minHeight: `${this.state.CustomStyle.questionStyle.height}px`,
            width: `${this.state.CustomStyle.questionStyle.width}%`,
            maxWidth: '100%',
            paddingLeft: `${this.state.CustomStyle.questionStyle.PaddingLeft}px`,
            paddingTop: `${this.state.CustomStyle.questionStyle.PaddingTop}px`,
            paddingRight: `${this.state.CustomStyle.questionStyle.PaddingRight}px`,
            paddingBottom: `${this.state.CustomStyle.questionStyle.PaddingBottom}px`,

            borderColor: this.state.CustomStyle.questionStyle.BorderColor !== 'transparent' ? this.state.CustomStyle.questionStyle.BorderColor : "",
            borderStyle: `${this.state.CustomStyle.questionStyle.BorderStyle}`,
            borderLeftWidth: `${this.state.CustomStyle.questionStyle.BorderWidthLeft}px`,
            borderRightWidth: `${this.state.CustomStyle.questionStyle.BorderWidthRight}px`,
            borderTopWidth: `${this.state.CustomStyle.questionStyle.BorderWidthTop}px`,
            borderBottomWidth: `${this.state.CustomStyle.questionStyle.BorderWidthBottom}px`,
            borderRadius: `${this.state.CustomStyle.questionStyle.BorderRadiusTop}${this.state.CustomStyle.questionStyle.BorderRadiusUnit} ${this.state.CustomStyle.questionStyle.BorderRadiusRight}${this.state.CustomStyle.questionStyle.BorderRadiusUnit} ${this.state.CustomStyle.questionStyle.BorderRadiusBottom}${this.state.CustomStyle.questionStyle.BorderRadiusUnit} ${this.state.CustomStyle.questionStyle.BorderRadiusLeft}${this.state.CustomStyle.questionStyle.BorderRadiusUnit}`,
            boxShadow: `${this.state.CustomStyle.questionStyle.ShadowPositionX}px ${this.state.CustomStyle.questionStyle.ShadowPositionY}px ${this.state.CustomStyle.questionStyle.ShadowRadius}px 0px ${this.state.CustomStyle.questionStyle.shadowColor}`,
        };

        let styleBackground = {
            height: `100%`,
            marginLeft: `-${this.state.CustomStyle.questionStyle.PaddingLeft}px`,
            marginTop: `-${this.state.CustomStyle.questionStyle.PaddingTop}px`,
            marginRight: `-${this.state.CustomStyle.questionStyle.PaddingRight}px`,
            marginBottom: `-${this.state.CustomStyle.questionStyle.PaddingBottom}px`,
            opacity: `${this.state.CustomStyle.questionStyle.Opacity}%`,
            backgroundColor: this.state.CustomStyle.questionStyle.backgroundColor !== 'transparent' ? this.state.CustomStyle.questionStyle.backgroundColor : "",
            backgroundImage: this.state.CustomStyle.questionStyle.backgroundImage !== '' ? `url('${this.state.CustomStyle.questionStyle.backgroundImage}')` : "",
            backgroundPositionX: `${this.state.CustomStyle.questionStyle.BgPositionX}%`,
            backgroundPositionY: `${this.state.CustomStyle.questionStyle.BgPositionY}%`,
            backgroundSize: `${this.state.CustomStyle.questionStyle.BgSize}`,
            backgroundRepeat: `${this.state.CustomStyle.questionStyle.BgRepeat}`,
            backgroundAttachment: `${this.state.CustomStyle.questionStyle.BgAttachment}`,
        };

        if (this.state.CustomStyle.questionTypeStyle.AnswerOrder === 'absolute') {
            style = { ...style, height: `${this.state.CustomStyle.questionStyle.height}px` };
        }

        let align = "x";
        if (this.state.CustomStyle.questionTypeStyle.AnswersAlign) {
            if (this.state.CustomStyle.questionTypeStyle.AnswersAlign === 'left') {
                align = "l";
            } else if (this.state.CustomStyle.questionTypeStyle.AnswersAlign === 'right') {
                align = "r";
            }
        }

        return (
            <div className={`w-${SizeView} mb-3 mx-auto`}>
                <style dangerouslySetInnerHTML={{ __html: statsStyles }} />
                <div className="bg-white w-100 p-3 form-group position-relative">
                    <QuestionTitle mark={mark} onEdit={onEdit} index={index} title={title} ResetAnswer={this.ResetAnswer} isExamQuestion={this.props.isExamQuestion} updateVersion={this.props.updateVersion}></QuestionTitle>
                    <div className="w-100" ref={this.designerContainer}>
                        <div className={`m${align}-auto position-relative overflow-hidden`} style={style} >
                            <div className="w-100 position-absolute" style={styleBackground} id={`SelectDesignerPreview_${Id}`} > </div>
                            <style dangerouslySetInnerHTML={{ __html: `#SelectDesignerPreview_${Id}{${this.state.CustomStyle.questionStyle.Custom} }` }}></style>
                            {this.renderCategories()}
                        </div>
                        {this.renderControlButton()}
                    </div>
                </div>
                {this.state.fullscreenMessageHtml && (
                    <div className="fullscreen-modal-overlay animate__animated animate__fadeIn animate__faster" onClick={() => this.setState({ fullscreenMessageHtml: null, fullscreenMessageQuestion: null })}>
                        <div className="fullscreen-modal-card animate__animated animate__zoomIn animate__faster" onClick={(e) => e.stopPropagation()}>
                            <div className="fullscreen-modal-header">
                                <h3 className="fullscreen-modal-title">
                                    <i className="fal fa-robot text-primary"></i>
                                    {t("Pages.Chatbot.FullScreenTitle") || "كامل الشاشة"}
                                </h3>
                                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                    <button
                                        type="button"
                                        className="fullscreen-modal-download-btn"
                                        onClick={() => this.handleDownloadResult(this.state.fullscreenMessageHtml, this.state.fullscreenMessageQuestion)}
                                        title={t("Pages.Chatbot.Download") || "تحميل"}
                                    >
                                        <i className="fal fa-download"></i>
                                        <span>{t("Pages.Chatbot.Download") || "تحميل"}</span>
                                    </button>
                                    <button
                                        className="fullscreen-modal-close-btn"
                                        onClick={() => this.setState({ fullscreenMessageHtml: null, fullscreenMessageQuestion: null })}
                                        title={t("cancel") || "إلغاء"}
                                    >
                                        <i className="fal fa-times"></i>
                                    </button>
                                </div>
                            </div>
                            <div className="fullscreen-modal-body bot-answer-html" dangerouslySetInnerHTML={{ __html: this.state.fullscreenMessageHtml }} />
                        </div>
                    </div>
                )}
                <AiStatsModal
                    isOpen={this.state.showStats}
                    onClose={() => this.setState({ showStats: false })}
                    stats={this.state.aiStats}
                    t={t}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        question: state.questions
    };
};

export default connect(mapStateToProps, { updateQuestion })(withTranslation('common')(FillTextView));